import { Box, Divider, Grid, Typography } from '@mui/material'
import { ButtonDialog } from '../../../components/overlays/ButtonDialog'
import { useScreenSize } from '../../../sharedComponents/src/hooks/useScreenSize'
import { useStoreActions, useStoreState } from '../../../store/hooks'
import { AchievementCard } from '../components/missions/AchievementCard'
import { ClaimedMission } from '../components/missions/ClaimedMission'
import { GuestBlocker } from '../components/missions/GuestBlocker'
import { LoadError, Loader } from '../components/missions/Loader'

export const AchievementsTab = () => {
    const { isMobile } = useScreenSize()
    const rewards = useStoreState((state) => state.missionsService.rewards)
    const guestEnabled = useStoreState((state) => state.missionsService.guestEnabled)
    const summaryError = useStoreState((state) => state.missionsService.summaryError)
    const getMissions = useStoreActions((state) => state.missionsService.getMissions)

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={2}
            width="100%"
            position="relative"
            sx={{
                '>:first-child': {
                    mb: -1,
                },
                p: '8px !important',
                pt: '0 !important',
                overflowY: 'auto',
                overflowX: 'hidden',
                borderRadius: 0,
            }}
        >
            {!guestEnabled && <GuestBlocker variant="missions" />}
            {!rewards && (summaryError ? <LoadError onRetry={() => getMissions()} /> : <Loader />)}
            {rewards?.map((reward, index) => (
                <Box sx={{ pb: 1.5 }} key={reward.category.id}>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant={isMobile ? 'h6' : 'h5'} textTransform="uppercase" fontWeight="bold">
                            {reward.category.name}
                        </Typography>
                        {index === 0 && <ButtonDialog variant="tiering-faq" />}
                    </Box>
                    <Divider sx={{ mb: 1.5, mt: 0.5, backgroundColor: 'common.white', height: '2px' }} />

                    <Grid container width="calc(100% + 10px)" pl="2px" spacing={1.5}>
                        {reward.achievements?.map((achievement) => (
                            <AchievementCard key={achievement.missionId} achievement={achievement} />
                        )) || (
                            <Grid item xs={4} sm={3} md={2} lg={2}>
                                <ClaimedMission />
                            </Grid>
                        )}
                    </Grid>
                </Box>
            ))}
        </Box>
    )
}
